import React from "react";
import { Typography, Paper, useTheme } from "@mui/material";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

function ApplicationInstallationStatusChart({ data }) {
  const theme = useTheme();
  const COLORS = [theme.palette.secondary.main, theme.palette.error.main];
  return (
    <Paper
      style={{ backgroundColor: theme.palette.success.main }}
      elevation={3}
      sx={{ padding: 2 }}
    >
      <Typography color={theme.palette.info.main} variant="h6" gutterBottom>
        Application Installation Status
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) =>
              `${name}: ${(percent * 100).toFixed(0)}%`
            }
            outerRadius={120}
            fill={theme.palette.secondary.main}
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </Paper>
  );
}

export default ApplicationInstallationStatusChart;
